import {types} from "mobx-state-tree";
import Parameter from "./Parameter";


const Parameters = types.model('Parameters', {
  codeParamType: types.optional(types.array(types.string), []),
  scanParamType: types.optional(types.array(types.string), []),
  countParamType: types.optional(types.array(types.string), []),
  premiumParamType: types.optional(types.array(types.string), []),
  customParamType: types.optional(types.array(types.string), []),
  gs1ParamType: types.optional(types.array(types.string), []),
  edParamType: types.optional(types.array(types.string), []),
  batchCodeParamTypeLock: types.optional(types.boolean, false), // those are only for batch
  batchScanParamTypeLock: types.optional(types.boolean, false),
  batchCountParamTypeLock: types.optional(types.boolean, false),
  batchPremiumParamTypeLock: types.optional(types.boolean, false),
  batchCustomParamTypeLock: types.optional(types.boolean, false),
  batchGS1ParamTypeLock: types.optional(types.boolean, false),
  batchEDParamTypeLock: types.optional(types.boolean, false),
}).actions(self => ({
  setParameters(paramType, parameters) {
    self[paramType] = parameters
  },
  hydrateParameters(parameters) {
    parameters?.codeParamType && (self.codeParamType = parameters?.codeParamType)
    parameters?.scanParamType && (self.scanParamType = parameters?.scanParamType)
    parameters?.countParamType && (self.countParamType = parameters?.countParamType)
    parameters?.premiumParamType && (self.premiumParamType = parameters?.premiumParamType)
    parameters?.customParamType && (self.customParamType = parameters?.customParamType)
    parameters?.gs1ParamType && (self.gs1ParamType = parameters?.gs1ParamType)
    parameters?.edParamType && (self.edParamType = parameters?.edParamType)
    // self.batchCodeParamTypeLock = parameters?.batchCodeParamTypeLock || false
    // self.batchScanParamTypeLock = parameters?.batchScanParamTypeLock || false
    // self.batchCountParamTypeLock = parameters?.batchCountParamTypeLock || false
    // self.batchPremiumParamTypeLock = parameters?.batchPremiumParamTypeLock || false
    // self.batchCustomParamTypeLock = parameters?.batchCustomParamTypeLock || false
    // self.batchGS1ParamTypeLock = parameters?.batchGS1ParamTypeLock || false
    // self.batchEDParamTypeLock = parameters?.batchEDParamTypeLock || false
  },
  clearParams() {
    self.resetCodeParams()
    self.resetScanParams()
    self.resetCountParams()
    self.resetPremiumParams()
    self.resetCustomParams()
    self.resetGS1Params()
    self.resetEDParams()
  },
  resetCodeParams() {
    self.codeParamType = []
    self.batchCodeParamTypeLock = false
  },
  resetScanParams() {
    self.scanParamType = []
    self.batchScanParamTypeLock = false
  },
  resetCountParams() {
    self.countParamType = []
    self.batchCountParamTypeLock = false
  },
  resetPremiumParams() {
    self.premiumParamType = []
    self.batchPremiumParamTypeLock = false
  },
  resetCustomParams() {
    self.customParamType = []
    self.batchCustomParamTypeLock = false
  },
  resetGS1Params() {
    self.gs1ParamType = []
    self.batchGS1ParamTypeLock = false
  },
  resetEDParams() {
    self.edParamType = []
    self.batchEDParamTypeLock = false
  }
}))


export default Parameters;
